module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/room-icon-ac301c212ac96cf2263a1bf8ef7d6bf3.png";